import { useEffect, useState } from 'react';

const readTheme = () => {
  if (typeof document === 'undefined') {return 'light';}
  return document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light';
};

// Subscribes to changes to `document.documentElement.dataset.theme`.
// Used by Logo and any other component that needs to render differently
// depending on the active theme (set by the UserStatus menu).
const useTheme = () => {
  const [theme, setTheme] = useState(readTheme);

  useEffect(() => {
    if (typeof document === 'undefined' || typeof MutationObserver === 'undefined') {return undefined;}
    const root = document.documentElement;
    const observer = new MutationObserver(() => setTheme(readTheme()));
    observer.observe(root, { attributes: true, attributeFilter: ['data-theme'] });
    // Sync once after mount in case the attribute was set before subscription.
    setTheme(readTheme());
    return () => observer.disconnect();
  }, []);

  return theme;
};

export default useTheme;
